import { computed, inject } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute, useRouter } from "vue-router";
import html_iway from "./template.iway.html?raw";
import { ShoppingCart, SquareMenu, University, SlidersHorizontal, Rocket } from "lucide-vue-next";
import { optionsProviderKey, type OptionsNavigationPath } from "../../../infrastructure/options_provider";
const app_theme = import.meta.env.VITE_APP_THEME;
let html = "";
if ("iway" == app_theme) {
  html = html_iway;
} else if ("lic" == app_theme) {
  html = html_iway;
} else if ("sak" == app_theme) {
  html = html_iway;
}
export default {
  template: html,
  components: { ShoppingCart, SquareMenu, University, SlidersHorizontal, Rocket },
  setup() {
    const { t } = useI18n();
    const route = useRoute();
    const router = useRouter();
    const optionsProvider = inject(optionsProviderKey)


    const optionPathes = computed<OptionsNavigationPath[]>(() => {
      return optionsProvider?.optionPathes.value ?? [];
    })
    
    const skip = function(){
      router.push("/configs")

    }
    const currentWidth = computed(() => {
      let w = 0 == optionPathes.value.length 
        ? 30 
        : 100 / optionPathes.value.length;
      let idx = 0;
      for(let i=0; i< optionPathes.value.length; i++){
        if (optionPathes.value[i].path == route.path){
          idx = i;
        }
      }
      return w * (idx+1);
    })

    const currentName = computed(() => {
      for(let i=0; i< optionPathes.value.length; i++){
        if (optionPathes.value[i].path == route.path){
          return optionPathes.value[i].title;
        }
      }
      return "OptionsNavigation_NoOptions";

    })

    return {
      t,
      optionPathes,
      currentWidth,
      currentName,
      skip
    }
  }
}
